import Api from '@/services/api.js';

export default {
  addContractor(details) {
    return Api.post('contractors/', details);
  },
  getAllContractors() {
    return Api.get('contractors/');
  },
  deleteContractor(contractor) {
    return Api.delete(`contractors/${contractor}`);
  },
  updateContractor(contractor) {
    var contractorId = contractor.id;
    return Api.put(`contractors/${contractorId}`, contractor);
  },
  getContractorsByContractor(contractor) {
    return Api.get('contractors/byContractor/' + contractor);
  },
}